export const responseErrors = (response, title) => {
  let errors = [{ msg: 'Erro desconhecido' }];

  const catchError =
    response?.data?.message ||
    response?.data?.error?.message ||
    response?.data?.error?.errors ||
    response?.data?.errors ||
    null;

  const extractUniversityName = (msg) => {
    const match = msg.match(/at (.*?) -/);
    return match ? match[1] : null;
  };

  const formatSignerError = (msg) => {
    const university = extractUniversityName(msg);
    return university
      ? `Assinador já existe e pertence a ${university}`
      : 'Assinador já existe';
  };

  if (catchError && typeof catchError === 'string') {
    if (/SignerId \d+ already exists/.test(catchError)) {
      errors[0].msg = formatSignerError(catchError);
    } else {
      errors[0].msg = catchError;
    }
  } else if (catchError && typeof catchError !== 'string') {
    const keys = Object.keys(catchError);

    if (keys.includes('0')) {
      errors = [];
      keys.forEach((key) => {
        if (key !== 'message') {
          const obj = {};

          let errorMsg = catchError[key].msg || catchError[key].message;

          if (/SignerId \d+ already exists/.test(errorMsg)) {
            errorMsg = formatSignerError(errorMsg);
          }

          Object.assign(
            obj,
            catchError[key].param && {
              param: catchError[key].param,
            },
            errorMsg && {
              msg: errorMsg,
            }
          );

          errors.push(obj);
        }
      });
    }
  }

  return {
    icon: 'error',
    title,
    html: `
    <ul style="display: table; margin:0 auto">
    ${errors
      .map((error) =>
        error.param
          ? `<li>${error.param} - ${error.msg}</li>`
          : `<li>${error.msg}</li>`
      )
      .join('')}
    </ul>
    `,
  };
};
